import styled, { css } from 'styled-components';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const BoxStyled = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-qh4od4-0"
})(["border-radius:", ";", " box-sizing:border-box;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  theme,
  $square
}) => $square ? theme.border.radius.square : theme.border.radius.large, ({
  theme,
  $bgColor
}) => $bgColor && css(["background-color:", ";"], theme.surface[$bgColor]), ({
  $flex
}) => css(["flex:", ";"], $flex), ({
  $basis
}) => css(["flex-basis:", ";"], $basis), ({
  $grow
}) => css(["flex-grow:", ";"], $grow), ({
  $shrink
}) => css(["flex-shrink:", ";"], $shrink), ({
  $order
}) => css(["order:", ";"], $order), ({
  $alignSelf
}) => css(["align-self:", ";"], $alignSelf), ({
  $justifySelf
}) => css(["justify-self:", ";"], $justifySelf), ({
  $placeSelf
}) => css(["place-self:", ";"], $placeSelf), ({
  $area
}) => css(["grid-area:", ";"], $area), ({
  $row
}) => css(["grid-row:", ";"], $row), ({
  $column
}) => css(["grid-column:", ";"], $column), ({
  $columnStart
}) => css(["grid-column-start:", ";"], $columnStart), ({
  $columnEnd
}) => css(["grid-column-end:", ";"], $columnEnd), ({
  $rowStart
}) => css(["grid-row-start:", ";"], $rowStart), ({
  $rowEnd
}) => css(["grid-row-end:", ";"], $rowEnd), paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));

export { BoxStyled as B };
//# sourceMappingURL=Box.styles-CmNQU4ci.js.map
